export default "__VITE_ASSET__ead23d48__"